import React from 'react';
import { Container, Row, Col } from "react-bootstrap";
import colorSharp2 from "../assets/img/color-sharp2.png";
import 'animate.css';
import TrackVisibility from 'react-on-screen';
import cardanoBlog from '../assets/img/Cardano-Blog.png';
import zkBlogs from '../assets/img/ZK-blog.png';
import { ProjectCard } from './ProjectCard';

export const Blogs = () => {

  const blogs = [
    {
      title: "Beginner’s intro to ZK Proofs and ZK Rollups.",
      url: "https://medium.com/@bvp1020mu/beginners-intro-to-zk-proofs-and-zk-rollups-2673468ab58",
      imgUrl: zkBlogs, // Replace with the actual image URL
    },
    {
      title: "How Cardano’s new algorithmic stable coin $DJED will be different from TerraUSD.",
      url: "https://medium.com/@bvp1020mu/how-cardanos-new-algorithmic-stable-coin-djed-will-be-different-from-terrausd-bdcde032526a",
      imgUrl: cardanoBlog, // Replace with the actual image URL
    },
  ];

  return (
    <section className="project"> 
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Blogs</h2>
                  <p>Welcome to my blogs section! Here are some of the exciting blogs I've written to explore the ever-evolving world of technology and blockchain:</p> {/* Adjusted the text for Blogs */}
                  <Row>
                    {
                      blogs.map((blog, index) => {
                        return (
                          <ProjectCard
                            key={index}
                            {...blog}
                          />
                        )
                      })
                    }
                  </Row>
                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
      <img className="background-image-right" src={colorSharp2} alt="Image"></img>
    </section>
  )
}
